// extracted by mini-css-extract-plugin
export default {"breakpointxs":"0","help-articles__title":"HelpCentreArticles_help-articles__title__8vaba"};